<template>
  <p v-html="text">{{ text }}</p>
</template>

<script>
export default {
  name: 'Paragraph',

  props: ['text'],
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/typo/Paragraph.vue